import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import { OptionType } from 'UIComponents/types/OptionTypes';
import { TINYMCE_PREVENT_BLUR_CLASSNAME } from 'data-token-picker/constants/TinyMCEHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const CategorySelectPropTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(OptionType.isRequired).isRequired,
  onChange: PropTypes.func.isRequired
};
const CategorySelect = ({
  value,
  options,
  onChange
}) => {
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "token-type-select",
    searchClassName: TINYMCE_PREVENT_BLUR_CLASSNAME,
    onChange: onChange,
    options: options,
    placeholder: "Select a type",
    value: value
  });
};
CategorySelect.propTypes = CategorySelectPropTypes;
CategorySelect.displayName = 'CategorySelect';
export default CategorySelect;